import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { Reservation, ReservationStatus } from './reservation.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
import { HttpClient, HttpResponse} from '@angular/common/http';


@Injectable()
export class ReservationService extends AbstractEntityService {

    protected resourceUrl = 'api/reservations';
    private resourceSearchUrl = 'api/_search/reservations';
    protected resourceCountUrl = 'api/_search/count/reservations';

    constructor(protected http: HttpClient) {  super(http); }

    create(reservation: Reservation, bypassRules: boolean, overwriteCard: boolean = false): Observable<Reservation> {
        let copy: Reservation = Object.assign({}, reservation);
        const params = this.buildParams(bypassRules, overwriteCard);

        return this.http.post<Reservation>(this.resourceUrl + params, copy).map((res: Reservation) => {
            return res;
        });

    }

    update(reservation: Reservation, bypassRules: boolean, overwriteCard: boolean = false): Observable<Reservation> {
        let copy: Reservation = Object.assign({}, reservation);
        const params = this.buildParams(bypassRules, overwriteCard);

        return this.http.put<Reservation>(this.resourceUrl + params, copy).map((res: Reservation) => {
            return res;
        });
    }

    private buildParams(bypassRules: boolean, overwriteCard: boolean): string {
        const paramList: string[] = [];

        if (bypassRules) {
            paramList.push('bypassRules');
        }
        if (overwriteCard) {
            paramList.push('overwriteCard');
        }

        return paramList.length ? `?params=${paramList.join(',')}` : '';
    }

    find(id: number): Observable<Reservation> {
        return this.http.get<Reservation>(`${this.resourceUrl}/${id}`).map((res: Reservation) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<Reservation[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Reservation[]>>(this.resourceUrl, options)
            ;
    }

    findAllByReservationFamilyId(id?: number): Observable<HttpResponse<Reservation[]>> {
        let options = this.createRequestOption();
        return this.http.get<HttpResponse<Reservation[]>>(`${this.resourceUrl}/from-reservation-family/${id}`, options)
            ;
    }

    search(req?: any): Observable<HttpResponse<Reservation[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<Reservation[]>>(this.resourceSearchUrl, options)
            ;
    }

    countByReservationFamilyId(id?: number): Observable<number> {
        let options = this.createRequestOption();
        options['responseType'] = 'text';
        return this.http.get<HttpResponse<any>>(`${this.resourceUrl}/count/from-reservation-family/${id}`, options)
            .map((res: any) => {
                return parseInt(res.body.length !== 0 ? res.body.toString() : 0, 10);
            });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation/reservation.service.ts